(function () {
  const TABLE_ID = 'availability-by-store';
  let currentRequestId = 0;
  let renderedVariantId = null;
  let settleTimer = null;
  let productData = null;

  function normalizeText(t) { return (t || '').replace(/\s+/g, ' ').trim(); }
  function escapeHtml(s) {
    return (s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#039;');
  }
  function getRootUrl() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root : '/';
  }

  function getCurrentVariantId() {
    const urlId = new URLSearchParams(location.search).get('variant');
    if (urlId) return urlId;
    const fi = document.querySelector('product-form form input[name="id"]');
    return fi && fi.value ? fi.value : null;
  }

  async function getProductData() {
    if (productData) return productData;
    const m = location.pathname.match(/\/products\/([^\/\?]+)/);
    if (!m) return null;
    try {
      const res = await fetch(getRootUrl() + 'products/' + m[1] + '.js', { credentials: 'same-origin' });
      productData = await res.json();
      return productData;
    } catch (e) { return null; }
  }

  function isVariantAvailable(product, variantId) {
    if (!product || !product.variants) return null;
    const v = product.variants.find(function (x) { return String(x.id) === String(variantId); });
    return v ? !!v.available : null;
  }

  function renderLoading(text) {
    const c = document.getElementById(TABLE_ID);
    if (!c) return;
    c.innerHTML =
      '<div class="cm-availability-box">' +
        '<div class="cm-availability-title">Disponibilidad por sucursal</div>' +
        '<p class="cm-availability-empty">' + escapeHtml(text) + '</p>' +
      '</div>';
  }

  function getLocationName(item, index) {
    const el =
      item.querySelector('.pickup-availability-list__location') ||
      item.querySelector('.store-availability-list__location') ||
      item.querySelector('[data-pickup-availability-location]') ||
      item.querySelector('h3, h4, strong');
    return normalizeText(el ? el.textContent : '') || ('Sucursal ' + (index + 1));
  }

  function getStatusText(item, locationName) {
    const el =
      item.querySelector('.pickup-availability-list__stock') ||
      item.querySelector('.store-availability-list__item-status') ||
      item.querySelector('[data-pickup-availability-status]') ||
      item.querySelector('[data-store-availability-status]') ||
      item.querySelector('p');
    let d = normalizeText(el ? el.textContent : '');
    if (!d) {
      d = normalizeText(item.textContent);
      if (locationName) d = normalizeText(d.replace(locationName, ''));
    }
    return d;
  }

  function isImmediateAvailable(detail) {
    const t = normalizeText(detail).toLowerCase();
    return t.indexOf('listo en 1 hora') !== -1 || t.indexOf('ready in 1 hour') !== -1 ||
      t.indexOf('generalmente listo') !== -1 || t.indexOf('normalmente está listo') !== -1 ||
      t.indexOf('normalmente esta listo') !== -1;
  }

  function buildRows(html, variantAvailable) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const items = doc.querySelectorAll(
      '.pickup-availability-list__item, .store-availability-list__item, [data-pickup-availability-item], [data-store-availability-item]'
    );

    const rows = [];
    items.forEach(function (item, i) {
      const location = getLocationName(item, i);
      const immediate = variantAvailable && isImmediateAvailable(getStatusText(item, location));
      rows.push({
        location: location,
        label: immediate ? 'Disponible ahora' : 'Sin existencias',
        type: immediate ? 'now' : 'none',
        detail: immediate ? 'Compra en línea y asegura tu compra' : 'Sin existencias en esta sucursal'
      });
    });

    const anyStock = variantAvailable && rows.some(function (r) { return r.type === 'now'; });
    rows.unshift({
      location: '🚚 Envíos',
      label: anyStock ? 'Disponible para envío' : 'Sin existencias',
      type: anyStock ? 'now' : 'none',
      detail: anyStock ? 'Disponible para envío a domicilio 🚚' : 'Sin existencias para envío'
    });
    return rows;
  }

  function renderRows(rows) {
    const c = document.getElementById(TABLE_ID);
    if (!c) return;
    if (!rows || rows.length === 0) {
      renderLoading('No pudimos cargar la disponibilidad en este momento.');
      return;
    }
    const body = rows.map(function (r) {
      return '<tr>' +
        '<td class="store-name">' + escapeHtml(r.location) + '</td>' +
        '<td><div class="cm-status-wrap">' +
          '<span class="cm-badge is-' + r.type + '">' + escapeHtml(r.label) + '</span>' +
          '<div class="cm-status-detail">' + escapeHtml(r.detail) + '</div>' +
        '</div></td></tr>';
    }).join('');

    c.innerHTML =
      '<div class="cm-availability-box">' +
        '<div class="cm-availability-title">Disponibilidad por sucursal</div>' +
        '<table class="cm-availability-table">' +
          '<thead><tr><th>Sucursal</th><th>Estatus</th></tr></thead>' +
          '<tbody>' + body + '</tbody>' +
        '</table>' +
      '</div>';
  }

  async function update(variantId) {
    const requestId = ++currentRequestId;
    if (!variantId) return;

    const c = document.getElementById(TABLE_ID);
    if (c) c.dataset.variantId = variantId;

    try {
      const product = await getProductData();
      const variantAvailable = isVariantAvailable(product, variantId);

      const html = await fetch(
        getRootUrl() + 'variants/' + variantId + '/?section_id=pickup-availability',
        { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } }
      ).then(function (r) { return r.text(); });

      if (requestId !== currentRequestId) return;

      const avail = variantAvailable === null ? true : variantAvailable;
      renderRows(buildRows(html, avail));
    } catch (e) {
      console.error('Error disponibilidad:', e);
      renderLoading('No pudimos cargar la disponibilidad en este momento.');
    }
  }

  function scheduleRender(delay) {
    if (settleTimer) clearTimeout(settleTimer);
    settleTimer = setTimeout(function () {
      const id = getCurrentVariantId();
      if (id && id !== renderedVariantId) {
        renderedVariantId = id;
        update(id);
      }
    }, delay);
  }

  function init() {
    if (!document.getElementById(TABLE_ID)) return;
    scheduleRender(0);

    document.addEventListener('change', function (e) {
      if (e.target.closest('variant-selects') || e.target.closest('variant-radios')) {
        scheduleRender(250);
      }
    });
    document.addEventListener('variant:change', function () { scheduleRender(250); });
    document.addEventListener('variantChange', function () { scheduleRender(250); });

    setInterval(function () {
      const id = getCurrentVariantId();
      if (id && id !== renderedVariantId) scheduleRender(250);
    }, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();